import { ApiResponse } from "helpers/fetch-wrapper";
import { CategoryRequests } from "queries/category-queries";

export interface Category {
    id: string;
    name: string;
}

export async function getCategoriesAction() {
    try {
        const response = await CategoryRequests.getCategories();
        const data: Category[] = await response.json();

        const apiResponse: ApiResponse<Category[]> = {
            body: data,
            message: response.status === 200 ? 'Categories fetched' : (data as any)['message'],
            status: response.status,
            error: response.status === 200 ? null : (data as any)['message'],
        }

        return apiResponse;
    } catch (err) {
        const apiResponse: ApiResponse<Category[]> = {
            body: [],
            message: 'Failed to fetch categories',
            status: 500,
            error: err as string,
        }
        return apiResponse;
    }
}

export async function createCategoryAction(name: string) {
    try {
        const response = await CategoryRequests.createCategory({ name });
        const data: Category = await response.json();

        const apiResponse: ApiResponse<Category> = {
            body: data,
            message: response.status === 201 ? 'Category created' : (data as any)['message'],
            status: response.status,
            error: response.status === 201 ? null : (data as any)['message'],
        }

        return apiResponse;
    } catch (err) {
        const apiResponse: ApiResponse<Category> = {
            body: null as any,
            message: 'Failed to create category',
            status: 500,
            error: err as string,
        }
        return apiResponse;
    }
}
